/*
  Back-to-top button (mobile only, styled in back-to-top.css).
  Shows after SHOW_AFTER px of scroll and scrolls the page to the top on tap.
*/
(function () {
  var button = document.querySelector('[data-back-to-top]');
  if (!button || button.__backToTopInit) return;
  button.__backToTopInit = true;

  var SHOW_AFTER = 1500;
  var ticking = false;
  var visible = false;

  function update() {
    ticking = false;
    var show = (window.pageYOffset || document.documentElement.scrollTop) > SHOW_AFTER;
    if (show === visible) return;
    visible = show;
    if (show) button.hidden = false;
    button.classList.toggle('is-visible', show);
    button.tabIndex = show ? 0 : -1;
    button.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  button.addEventListener('click', function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  button.tabIndex = -1;
  button.setAttribute('aria-hidden', 'true');
  update();
})();
